import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from "react";
import { Field } from "formik";
import { TextField, CheckboxWithLabel } from "formik-material-ui";
import { Grid, Typography, FormControlLabel, makeStyles } from "../../..";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      display: "flex",
      "flex-wrap": "no-wrap",
      padding: "20px",
      "flex-direction": "column"
    },
    flex: {
      display: "flex"
    },
    mr30: {
      "margin-right": "30px"
    },
    w30: {
      width: "33%"
    },
    w45: {
      width: "50%"
    },
    w90: {
      width: "100%"
    }
  };
});

var FaceForm = function FaceForm(_ref) {
  var _React$createElement;

  var values = _ref.values,
      mode = _ref.mode,
      onChange = _ref.onChange,
      translation = _ref.translation;
  // console.log('translation.selects.client_type.items', translation.selects.client_type.items);
  var classes = useStyles();
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.root
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: /*#__PURE__*/React.createElement(Field, {
      label: "¿Cliente FACE?",
      name: "billingInfo.face",
      key: "billingInfo.face",
      component: CheckboxWithLabel,
      color: "primary",
      disabled: mode === "view"
    }),
    label: "¿Cliente FACE?"
  }), values.billingInfo.face && [/*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "\xD3rgano Gestor"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, (_React$createElement = {
    name: "billingInfo.face_data.nameGestor",
    key: "billingInfo.face_data.nameGestor",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: "Nombre"
  }, _defineProperty(_React$createElement, "label", "Nombre"), _defineProperty(_React$createElement, "component", TextField), _defineProperty(_React$createElement, "margin", "normal"), _defineProperty(_React$createElement, "variant", "outlined"), _defineProperty(_React$createElement, "disabled", mode === "view"), _React$createElement)), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.codeGestor",
    key: "billingInfo.face_data.codeGestor",
    className: [classes.w45].join(" "),
    label: "Código",
    placeholder: "Código",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.addressGestor",
    key: "billingInfo.face_data.addressGestor",
    className: [classes.mr30, classes.w90].join(" "),
    label: "Dirección",
    placeholder: "Dirección",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.zipCodeGestor",
    key: "billingInfo.face_data.zipCodeGestor",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Código postal",
    placeholder: "Código postal",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.townGestor",
    key: "billingInfo.face_data.townGestor",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Ciudad",
    placeholder: "Ciudad",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.provinceGestor",
    key: "billingInfo.face_data.provinceGestor",
    className: [classes.w30].join(" "),
    label: "Provincia",
    placeholder: "Provincia",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Unidad Tramitadora"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.nameTramitador",
    key: "billingInfo.face_data.nameTramitador",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: "Nombre",
    placeholder: "Nombre",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.codeTramitador",
    key: "billingInfo.face_data.codeTramitador",
    className: [classes.w45].join(" "),
    label: "Código",
    placeholder: "Código",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.addressTramitador",
    key: "billingInfo.face_data.addressTramitador",
    className: [classes.mr30, classes.w90].join(" "),
    label: "Dirección",
    placeholder: "Dirección",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.zipCodeTramitador",
    key: "billingInfo.face_data.zipCodeTramitador",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Código Postal",
    placeholder: "Código Postal",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.townTramitador",
    key: "billingInfo.face_data.townTramitador",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Ciudad",
    placeholder: "Ciudad",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.provinceTramitador",
    key: "billingInfo.face_data.provinceTramitador",
    className: [classes.w30].join(" "),
    label: "Provincia",
    placeholder: "Provincia",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Typography, {
    variant: "h6"
  }, "Oficina Contable"), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.nameContable",
    key: "billingInfo.face_data.nameContable",
    className: [classes.mr30, classes.w45].join(" "),
    fullWidth: true,
    label: "Nombre",
    placeholder: "Nombre",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.codeContable",
    key: "billingInfo.face_data.codeContable",
    className: [classes.w45].join(" "),
    label: "Código",
    placeholder: "Código",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.addressContable",
    key: "billingInfo.face_data.addressContable",
    className: [classes.mr30, classes.w90].join(" "),
    label: "Dirección",
    placeholder: "Dirección",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.zipCodeContable",
    key: "billingInfo.face_data.zipCodeContable",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Código Postal",
    placeholder: "Código Postal",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.townContable",
    key: "billingInfo.face_data.townContable",
    className: [classes.mr30, classes.w30].join(" "),
    label: "Ciudad",
    placeholder: "Ciudad",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }), /*#__PURE__*/React.createElement(Field, {
    name: "billingInfo.face_data.provinceContable",
    key: "billingInfo.face_data.provinceContable",
    className: [classes.w30].join(" "),
    label: "Provincia",
    placeholder: "Provincia",
    component: TextField,
    margin: "normal",
    variant: "outlined",
    disabled: mode === "view"
  }))]);
};

export { FaceForm };